import LivePlayer from './LivePlayer';

export default LivePlayer;
